import * as React from "react";
import {cs} from "../../../../react/chain-services";
import "./ml-warning-table.scss";

import {cx}                     from "emotion";
import {UseState}               from "../../../../react/use-state";
import {DataTableD1}            from "../../common/design2/data-table/data-table-d1";
import {PageSize}               from "../../common/design2/pagination-ui/page-size/page-size";
import {PageList}               from "../../common/design2/pagination-ui/page-list/page-list";
import {EditActionInTable}      from "../../common/design2/data-table-ui/edit-action-in-table/edit-action-in-table";

import {EditMailingListModal}   from "../ml-list-table/edit-mailing-list-modal/edit-mailing-list-modal";

export const MLWarningTable = ({entityId, mailingLists, loading, xdQaNamePrefix=undefined}) => cs(
    ["pageSize", (_, next) => UseState({initValue: 10, next})],
    ["editMailingListModal", (_, next) => EditMailingListModal({entityId, next})],
    ({pageSize, editMailingListModal}) => DataTableD1({
        darkRows: "even",
        getDefaultSorting: () => ({
            columnIndex: 2,
            direction: "desc",
        }),
        className: cx("ml-warning-table-13h"),

        columns: Columns({xdQaNamePrefix}),
        rows: mailingLists?.map((r) => ({
            key: r.id,
            xdQaName: r.mailingListName,
            columns: [
                {
                    render: () => r.mailingListName,
                    sortValue: () => r.mailingListName.toLowerCase(),
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix + " " : "") + "Recipient Name",
                    },
                },
                {
                    render: () => (r.count - r.warningCount),
                    sortValue: () => r.count,
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix + " ": "") + "Pass Count",
                    },
                },
                {
                    render: () => r.failedCount,
                    sortValue: () => r.failedCount,
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix + " ": "") + "Fail Count",
                    },
                },
                {
                    render: () => r.warningCount,
                    sortValue: () => r.warningCount,
                    domAttrs: {
                        "xd-qa-type": "label",
                        "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix + " ": "") + "Warning Count",
                    },
                },
                {
                    render: () => <>
                        {EditActionInTable({
                            onClick: () => editMailingListModal.show({
                                ml: r,
                            }),
                            xdQaName: r.mailingListName,
                        })}
                    </>,
                },
            ].filter(v=>v),
        })),
        emptyAction: {
            label: loading? "Loading..." : "No addresses",
        },
        pageSize: pageSize.value,
        getFooter: ({colCount, pagination}) => ({
            columns: [
                {
                    colSpan: colCount,
                    render: () => mailingLists.length > 10 && (
                        <div className="controls">
                            {PageSize({state: pageSize, xdQaNamePrefix})}

                            {pagination.active && (
                                <div className="page-list">
                                    {PageList({...pagination, xdQaNamePrefix})}
                                </div>
                            )}
                        </div>
                    ),
                },
            ],
        }),
    }),
);


const Columns = ({xdQaNamePrefix}) => [
    {
        width: "1%",
        label: "ADDRESS LIST NAME",
        className: "name",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"Address List Name",
        },
    },
    {
        width: "1%",
        label: "PASS",
        className: "Pass",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"pass",
        },
    },
    {
        width: "1%",
        label: "FAILED",
        className: "Failed",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"failed",
        },
    },
    {
        width: "1%",
        label: "WARNING",
        className: "Warning",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"warning",
        },
    },
    {
        width: "1%",
        label: "",
        className: "actions",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": (xdQaNamePrefix ? xdQaNamePrefix+" " : "")+"action",
        },
    },
].filter(v=>v);